import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import { Text } from '@zillow/constellation';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import AppSelectors from 'app/shared/selectors/AppSelectors';

import DropzoneConstants from 'app/shared/constants/DropzoneConstants';
import { StyledDropzoneContainer } from './StyledComponents';

const DropzoneWrapper = ({
    includeMaxSize = false,
    isScreenMobile,
    isUploading,
    isUploadingCaption,
    multiple = false,
    onDrop,
    onDropRejected,
}) => {
    const optionalProps = {};
    const {
        DROPZONE_MAX_FILESIZE,
        MAIN_TEXT,
        SUB_TEXT,
    } = DropzoneConstants;

    const mainText = isScreenMobile ? MAIN_TEXT.MOBILE : MAIN_TEXT.DESKTOP;
    const subText = isScreenMobile ? SUB_TEXT.MOBILE : SUB_TEXT.DESKTOP;

    if (includeMaxSize) {
        optionalProps.maxSize = DROPZONE_MAX_FILESIZE;
    }
    if (multiple) {
        optionalProps.multiple = true;
    }

    return (
        <StyledDropzoneContainer
            accept="image/*"
            caption=""
            className={cx(['DropzoneWrapper', 'needsclick'])}
            isUploading={isUploading}
            isUploadingCaption={isUploadingCaption}
            multiple={multiple}
            onDrop={onDrop}
            onDropRejected={onDropRejected}
            name="sourceFile"
            {...optionalProps}
        >
            {isUploading ? (
                <SpinnerContainer size="lg" />
            ) : (
                <React.Fragment>
                    <Text as="div" fontType="sectionheading">
                        {mainText}
                    </Text>

                    <Text as="div" fontType="smallbody">
                        {subText}
                    </Text>
                </React.Fragment>
            )}
        </StyledDropzoneContainer>
    );
};

const mapStateToProps = state => ({
    isScreenMobile: AppSelectors.makeIsScreenMobile(state),
});

export default connect(mapStateToProps)(DropzoneWrapper);
